/**
 * 全局 IM 模块统一出口
 *
 * 使用方式：
 *   import { initIMClient, destroyIMClient, waitForIMReady } from '@/services/im';
 */
export { getUserSig } from './api';
export {
  destroyIMClient,
  getIMClient,
  initIMClient,
  isUserSigExpiredError,
  reconnectIMClient,
  subscribeIMInstance,
  waitForIMReady,
} from './client';
export { shouldUseExpireUserSigForTest } from './testSwitch';
export type {
  GetUserSigRequest,
  GetUserSigResponse,
  IMClientHandle,
  IMInstanceListener,
  InitIMOptions,
  UserSigData,
} from './types';
